import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import useAuthStore from '../store/authStore';

export default function LoginPage() {
  const { register, handleSubmit, formState: { errors } } = useForm();
  const { login, loading } = useAuthStore();
  const navigate = useNavigate();

  const onSubmit = async (data) => {
    try {
      await login(data.mobile, data.password);
      toast.success('Welcome back! 🙏');
      navigate('/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Login failed');
    }
  };

  return (
    <div className="min-h-screen bg-hero-gradient flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <Link to="/" className="inline-flex items-center gap-2">
            <img src="/cross-icon.png" alt="Cross" className="w-10 h-10 rounded object-cover mx-auto" />
          </Link>
          <h1 className="font-heading text-3xl font-bold text-white mt-2">Welcome Back</h1>
          <p className="text-primary-100 mt-1">Sign in to your account</p>
        </div>

        <div className="card p-8">
          <form onSubmit={handleSubmit(onSubmit)} className="space-y-5">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Mobile Number</label>
              <input
                type="tel"
                placeholder="10-digit mobile number"
                className="input-field"
                {...register('mobile', {
                  required: 'Mobile number is required',
                  pattern: { value: /^[6-9]\d{9}$/, message: 'Enter valid Indian mobile number' }
                })}
              />
              {errors.mobile && <p className="text-red-500 text-xs mt-1">{errors.mobile.message}</p>}
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Password</label>
              <input
                type="password"
                placeholder="Enter your password"
                className="input-field"
                {...register('password', { required: 'Password is required' })}
              />
              {errors.password && <p className="text-red-500 text-xs mt-1">{errors.password.message}</p>}
            </div>

            <button type="submit" disabled={loading} className="btn-primary w-full py-3 disabled:opacity-50">
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>

          <div className="cross-divider my-6">or</div>

          <p className="text-center text-sm text-gray-600">
            New to Holyweds?{' '}
            <Link to="/register" className="text-primary font-semibold hover:underline">Register Free</Link>
          </p>
        </div>

        <p className="text-center text-primary-200 text-xs mt-6">
          <img src="/cross-icon.png" alt="Cross" className="w-4 h-4 rounded object-cover inline-block align-text-bottom mr-1" /> "What God has joined together, let no one separate." — Mark 10:9
        </p>
      </div>
    </div>
  );
}
